import request from '@/utils/request'

/**
* 消息API
*
* @author Jay Qing
* @since 2021/11/08
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = 'system/message'

export const MESG_BASE_URL = BASE_URL

/**
* 分页查询接口
*
* @type {string}
*/
export const MESG_PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function msgGet(id: string) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
 * 查询指定ID的消息
 *
 * @param id ID
 * @returns {Promise}
 */
export function view(id: string) {
  return request({
    url: `${BASE_URL}/view/${id}`,
    method: 'get'
  })
}

/**
* 保存数据
*
* @param data 数据
* @returns {Promise}
*/
export function msgSave(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function msgUpdate(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
 * 更新状态
 *
 * @param data 新的状态
 * @return {Promise}
 */
export function updateStatus(data: any) {
  return request({
    url: `${BASE_URL}/status`,
    method: 'put',
    data: data
  })
}

/**
* 删除数据
*
* @param idList ID数组
* @returns {Promise}
*/
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
